import { Group, Stack, Text, Flex } from "@mantine/core"
import { PersonProfilePictureAvatar } from "../../../../-components/person-profile-picture-avatar"
import dayjs from "dayjs"
import { useElementSize } from "@mantine/hooks"
import { ellipsify } from "../../../../../../utils/ellipsify"
import { SimpleUser } from "@/orval/gen/model"

interface Props {
  author: SimpleUser | null | undefined
  authorSubtext?: string
  timeStamp: string
  rightSection?: React.ReactNode
}

export function PostHeader({
  author,
  authorSubtext,
  timeStamp,
  rightSection,
}: Props) {
  const { ref, width } = useElementSize()

  return (
    <Group gap={"xs"} ref={ref} w={"100%"} align="center" wrap="nowrap">
      {author?.personId ? (
        <PersonProfilePictureAvatar
          personId={author.personId}
          name={author.userName}
        />
      ) : null}
      <Stack gap={0} miw={0}>
        <Text truncate>{author?.userName}</Text>
        {authorSubtext ? (
          <Text truncate size="sm" c="dimmed">
            {authorSubtext}
          </Text>
        ) : null}
      </Stack>
      <Flex justify="flex-end" flex={1} wrap="wrap">
        <Text
          style={{ ...ellipsify, whiteSpace: undefined, textAlign: "right" }}
          size="sm"
          c="dimmed"
        >
          {dayjs(timeStamp).format(width < 400 ? "LT L" : "LT ddd L")}
        </Text>
      </Flex>
      {rightSection ?? null}
    </Group>
  )
}
